import React from "react";
import { CustomerTreeSelect_ItemFragment as Item, CustomerType } from "@graphql";
import { Earth, OfficeBuilding } from "mdi-material-ui";
import Select, { MultiSelectProps, Option } from "@components/Select";
import locale from "@bonliva-crm/locale";

export type CustomerTreeSelectProps = Omit<
  Partial<MultiSelectProps>,
  "options" | "value"
> & {
  expanded?: boolean;
  label?: string;
  items: Array<Item & { isGroupOpen?: boolean }>;
  value: string[];
};

export function CustomerTreeSelect(props: CustomerTreeSelectProps) {
  const { items, value: valueProp = [], multi = true, ...rest } = props;

  const options: Option[] = props.items.map((item) => {
    const Icon = icons[item.CustomerRef.Type];
    const icon = Icon && <Icon style={{ fontSize: 14, marginRight: 4 }} />;

    let description = "";
    if (item.CustomerRef.Type === CustomerType.Department) {
      const parent = items.find((y) => y.CustomerRef.Id === item.ParentId);

      description = parent ? parent.CustomerRef.Name : "parent not found";
    }

    return {
      icon,
      label: item.CustomerRef.Name,
      value: item.CustomerRef.Id,
      parent: item.ParentId,
      isGroupOpen: item.isGroupOpen ?? false,
      description,
      hasChildren: true,
      skipCheckbox: item.CustomerRef.Type === CustomerType.Region,
      unselectable: item.CustomerRef.Type === CustomerType.Region
    };
  });

  return (
    <Select
      {...rest}
      clearable={false}
      expanded={props.expanded}
      label={locale.ConnectedCustomer}
      fullWidth
      inputRenderer={(inputProps) => null}
      onFocusCustom={(instance) => instance.openMenu()}
      multi={multi}
      multiType="chips"
      nested
      groupBy="parent"
      optionType="checkbox"
      options={options}
      renderDescriptionInValues
      // value={value as any}
      value={valueProp}
    />
  );
}

const icons = {
  [CustomerType.Region]: Earth,
  [CustomerType.Hospital]: OfficeBuilding,
  [CustomerType.Department]: null
};
